export const fontFamily = 'Open Sans';
export const baseFontSize = '14px';
export const smallFontSize = '12px'; // 12
export const largeFontSize = '16px'; // 16
export const headingFontSize = '20px'; // 20
export const titleFontSize = '28px'; // 28

export const borderRadius = '5px';

/**
 * Standard spacings to use for margins/paddings/heights for dividers
 */
export const Spacing = {
  none: 0,
  xSmall: 2,
  small: 4,
  smallMedium: 6,
  medium: 8,
  mediumLarge: 12,
  large: 16,
  largeXLarge: 24,
  xLarge: 32,
  xLargeLarge: 48,
  xxLarge: 100,
  xxxLarge: 200
} as const;

/**
 * Standard Font families
 */
export const FontFamily = {
  primary: 'Public Sans'
} as const;

/**
 * Standard Font sizes
 */
export enum FontSize {
  xsmall = 10,
  small = 12,
  base = 14,
  medium = 15,
  large = 16,
  heading = 20,
  mediumHeading = 24,
  largeHeading = 28,
  title = 32,
  largeTitle = 42,
  xlarge = 48
}

export const FontWeight = {
  light: 300,
  normal: 400,
  semibold: 600,
  bold: 700
} as const;

/**
 * Standard Icon sizes
 */
export const IconSize = {
  small: 16,
  base: 24,
  large: 32,
  navMenu: 36,
  xLarge: 48
} as const;

/**
 * Standard Border radiuses
 */
export const BorderRadius = {
  none: 0,
  small: 3,
  base: 5,
  large: 10,
  xLarge: 24,
  full: 500
} as const;

/**
 * Standard drop shadows/elevation
 */
const createElevation = (elevation: number) => `0 1px ${elevation / 2}px rgba(0,0,0,0.2)`;

export const Elevation = {
  el0: 'none',
  el1: createElevation(1),
  el2: createElevation(2),
  el3: createElevation(3),
  el4: createElevation(4),
  el5: createElevation(5),
  el6: createElevation(6),
  el7: createElevation(7),
  el8: createElevation(8),
  el9: createElevation(9),
  el10: createElevation(10)
} as const;

/* zIndex values */

export const ZIndex = {
  max: 999,
  navigation: 100,
  spinner: 50,
  high: 30,
  medium: 20,
  low: 10,
  base: 1,
  min: -999
} as const;
